"use strict";
exports.__esModule = true;
exports.createRateFromRoomBasketOccupancy = void 0;
var money_1 = require("../../../core/money");
exports.createRateFromRoomBasketOccupancy = function (roomBasketOccupancy) {
    var _a;
    return {
        rateId: roomBasketOccupancy.rateId,
        offerId: roomBasketOccupancy.offerId,
        price: (_a = {},
            _a[money_1.PriceType.TotalPrice] = roomBasketOccupancy.price,
            _a),
        availableQuantity: roomBasketOccupancy.availableQuantity,
        taxes: roomBasketOccupancy.taxes,
        selectedQuantity: roomBasketOccupancy.selectedQuantity,
        description: roomBasketOccupancy.rateInformation,
        occupancy: {
            occupancyId: roomBasketOccupancy.occupancyId,
            isDefault: false,
            definition: roomBasketOccupancy.definition
        }
    };
};
//# sourceMappingURL=rate.js.map